"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieValuesFromRequest = void 0;
const ensureEncodedForJSCookie_1 = require("../../utils/cookie/ensureEncodedForJSCookie");
const getCookieValuesFromRequest = (request, cookieNames) => {
    const cookieHeader = request.headers.get('Cookie');
    if (!cookieHeader) {
        return {};
    }
    const cookieValues = cookieHeader
        .split(';')
        .map(cookie => cookie.trim().split('='))
        .reduce((result, [key, value]) => {
        result[key] = value;
        return result;
    }, {});
    // Cookie names are written via `ensureEncodedForJSCookie`, so they appear
    // percent-encoded on the wire when they contain unsafe characters (e.g. `@`
    // in email-based Cognito usernames). Match the lookup keys using the same
    // encoding so reads align with writes.
    const result = {};
    for (const cookieName of cookieNames) {
        result[cookieName] = cookieValues[(0, ensureEncodedForJSCookie_1.ensureEncodedForJSCookie)(cookieName)];
    }
    return result;
};
exports.getCookieValuesFromRequest = getCookieValuesFromRequest;
